import api from '@/api';
import store from '@/store';

const resource = 'ei/disciplina-dispensada';

export default {
  getAlunosDaTurmaDispensadosDaDisciplina(data) {
    return api.get(`${resource}/select-alunos-dispensados-disciplina`, {
      params: data,
    });
  },


};
